// Hide nav on scroll-down, show on scroll-up
(function () {
  var nav = document.querySelector('.bb-nav');
  if (!nav) return;
  var lastScroll = window.scrollY || 0;
  var ticking = false;
  function update() {
    var current = window.scrollY || 0;
    if (current > lastScroll && current > 80) {
      nav.classList.add('bb-nav--minimal');
    } else {
      nav.classList.remove('bb-nav--minimal');
    }
    lastScroll = current;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();
